
const d = (obj) => obj && obj.__esModule ? obj.default : obj;

const allValues = obj => {
  const keys = Object.keys(obj);
  return Promise.all(keys.map(k => obj[k])).then(values => {
    const next = {};
    keys.forEach((k, i) => {
      next[k] = values[i];
    });
    return next;
  });
};


const SCOPE = null;
const IMPORTS = {
'useFieldArray': () => allValues({
  "yup": import(/* webpackChunkName: "docpoc-useFieldArray" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"react-formal/useFieldArray": import(/* webpackChunkName: "docpoc-useFieldArray" */ '/Users/jquense/src/react-formal/src/useFieldArray.ts'),
"../components/FormWithResult": import(/* webpackChunkName: "docpoc-useFieldArray" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"../components/IconButton": import(/* webpackChunkName: "docpoc-useFieldArray" */ '/Users/jquense/src/react-formal/www/src/components/IconButton.js')
  }),
'useFormValues': () => allValues({
  "react-formal": import(/* webpackChunkName: "docpoc-useFormValues" */ '/Users/jquense/src/react-formal/src/index.ts')
  }),
'Field': () => allValues({
  "@docs/components/FormWithResult": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"../components/FormWithResult": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"react-widgets/lib/DropdownList": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/www/node_modules/react-widgets/lib/DropdownList.js'),
"yup": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"react-formal": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/src/index.ts'),
"react-formal": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/src/index.ts'),
"@docs/components/FormWithResult": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"yup": import(/* webpackChunkName: "docpoc-Field" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js')
  }),
'FieldArray': () => allValues({
  "yup": import(/* webpackChunkName: "docpoc-FieldArray" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"../components/FormWithResult": import(/* webpackChunkName: "docpoc-FieldArray" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"../components/IconButton": import(/* webpackChunkName: "docpoc-FieldArray" */ '/Users/jquense/src/react-formal/www/src/components/IconButton.js')
  }),
'Message': () => allValues({
  "yup": import(/* webpackChunkName: "docpoc-Message" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"react-formal": import(/* webpackChunkName: "docpoc-Message" */ '/Users/jquense/src/react-formal/src/index.ts')
  }),
'Form': () => allValues({
  "@docs/components/FormWithResult": import(/* webpackChunkName: "docpoc-Form" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"yup": import(/* webpackChunkName: "docpoc-Form" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"react-formal": import(/* webpackChunkName: "docpoc-Form" */ '/Users/jquense/src/react-formal/src/index.ts'),
"../components/Result": import(/* webpackChunkName: "docpoc-Form" */ '/Users/jquense/src/react-formal/www/src/components/Result.js'),
"@docs/components/FormWithResult": import(/* webpackChunkName: "docpoc-Form" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"yup": import(/* webpackChunkName: "docpoc-Form" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js')
  }),
'NestedForm': () => allValues({
  "react-formal": import(/* webpackChunkName: "docpoc-NestedForm" */ '/Users/jquense/src/react-formal/src/index.ts'),
"yup": import(/* webpackChunkName: "docpoc-NestedForm" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"usa-states": import(/* webpackChunkName: "docpoc-NestedForm" */ '/Users/jquense/src/react-formal/www/node_modules/usa-states/index.js')
  }),
'/getting-started': () => allValues({
  "@docs/components/FormWithResult": import(/* webpackChunkName: "docpoc--getting-started" */ '/Users/jquense/src/react-formal/www/src/components/FormWithResult.js'),
"@docs/components/FormWithErrors": import(/* webpackChunkName: "docpoc--getting-started" */ '/Users/jquense/src/react-formal/www/src/components/FormWithErrors.js'),
"yup": import(/* webpackChunkName: "docpoc--getting-started" */ '/Users/jquense/src/react-formal/node_modules/yup/es/index.js'),
"react-formal": import(/* webpackChunkName: "docpoc--getting-started" */ '/Users/jquense/src/react-formal/src/index.ts'),
"../fakeSaveToServer": import(/* webpackChunkName: "docpoc--getting-started" */ '/Users/jquense/src/react-formal/www/src/fakeSaveToServer.js')
  }),
};
import React from 'react';

import ExamplesContext from './ExamplesContext';

// eslint-disable-next-line no-undef
const context = { imports: IMPORTS, scope: SCOPE };

export default ({ element }) => (
  <ExamplesContext.Provider value={context}>{element}</ExamplesContext.Provider>
);
